import React from 'react';
import { Pane, Spinner } from 'evergreen-ui';

const Loading = ({height}) => {
  return (
    <Pane display="flex" alignItems="center" justifyContent="center" height={height || 400}>
      <Spinner />
    </Pane>
  );
};

export default Loading;
